<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Subadmin Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="sec_head_new sec_head_new_after">
                                <form [formGroup]="searchForm">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-4 col-md-4">
                                            <div class="filter_search mb20 width100">
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text"
                                                        formControlName="search" placeholder="Search by name"
                                                        maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group" type="button">
                                                            <img src="assets/img/icon-search.png" alt="Search"
                                                                (error)="onImageError($event)" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">

                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group row d-flex justify-content-end">
                                                <div class="ms-5 text-align-end text-nowrap" style="text-align: end">
                                                    <button type="button" routerLink="/add-subadmin"
                                                        class="btn btn-info link font17"
                                                        style="height: 35px;padding-top: 3px;">
                                                        <i class="fa fa-plus-circle" aria-hidden="true"> Add Sub Admin
                                                        </i>
                                                    </button>
                                                    <!-- <a class="link font17"><i class="fas fa-plus-circle mr-1"></i> Add Sub Admin</a> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>From date:</mat-label>
                                                <input matInput [max]="maxDate" id="fromDate" [matDatepicker]="picker"
                                                    formControlName="fromDate">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="fromDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="fromDate"> -->
                                        </div>
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>To Date :</mat-label>
                                                <input matInput [max]="maxDate" id="toDate" [matDatepicker]="picker1"
                                                    formControlName="toDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker1"></mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="toDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="toDate"> -->

                                        </div>
                                        <div class="col-md-8">
                                            <button type="button" class="btn btn-info" (click)="getSubAdminList()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-search"> Search </i>
                                            </button>

                                            <button class="btn btn-danger ms-2" type="button" (click)="Reset()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-undo"> Reset</i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Name</th>
                                        <th scope="col" class="Sorting-img">Email Address</th>
                                        <th scope="col" class="Sorting-img">Added on</th>
                                        <th scope="col" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of subAdminList| paginate: { itemsPerPage: itemPerPage, currentPage:
                                    currentPage, totalItems: total}; track item; let i = $index) {
                                    <tr class="text-center">
                                        <td class="content">{{i+1}}</td>
                                        <td class="content">{{item?.firstName}} {{item?.lastName}}</td>
                                        <td class="content">
                                            <abbr [title]="item?.email">
                                                {{item?.email}}

                                            </abbr>
                                        </td>
                                        <td class="content">{{item?.createdAt | date : 'd/M/y' :'UTC' }}</td>
                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin" title="view"
                                                (click)="viewSubadmin(item?._id)">
                                                <i class="fa fa-eye" style="color:white"></i></button>
                                            <button class="btn btn-info ms-2 bt-margin"
                                                (click)="editSubadmin(item?._id)"><i class="fa fa-edit"
                                                    style="color:white"></i></button>


                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                (click)="deleteUserModal(item?._id)"><i class="fa fa-trash"
                                                    style="color:white"></i></button>

                                            <label class="switch ms-2 mr-1"
                                                (click)="openActiveBlock(item?.status,item?._id)">
                                                <input type="checkbox" [checked]="item?.status == 'ACTIVE'">
                                                <span class="slider round"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    }
                                    @if(!subAdminList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="9">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination my-3 d-flex justify-content-end">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Subadmin?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this subadmin?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme"
                                        (click)="deleteSubadminApi()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->

<!-- Active and block subadmin user  -->

<div class="modal fade global-modal reset-modal" id="actBlockStatus">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    @if(subadminStatus == 'ACTIVE'){
                    <h5 class="modal-title d-inline-block">Block sub admin?</h5>
                    }
                    @else if(subadminStatus == 'BLOCK'){
                    <h5 class="modal-title d-inline-block"> Active sub admin?</h5>
                    }
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                @if(subadminStatus == 'ACTIVE'){
                                <p>Are you sure you want to block this sub admin?</p>
                                }
                                @else if(subadminStatus == 'BLOCK'){
                                <p>Are you sure you want to Active this sub admin?</p>
                                }
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="updateActiveBlock()"
                                        data-dismiss="modal">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>